import React from 'react'
import CourseDetail from '../../../modules/Course/Detail'

const CourseDetailPage = () => {
    return <CourseDetail />
}

export default CourseDetailPage